<template>
    <v-container fluid class="main-container d-block pa-0">
        <v-flex class="d-flex justify-space-between align-center mx-6 py-3">
            <div class="arrow-btn common-text d-inline-flex" @click="back">
                <div
                    v-html="require('!html-loader!@/assets/icons/arrow_down_icon.svg')"
                    class="d-inline-flex rotate-90 size-28"
                />
            </div>
            <div class="title-text d-inline-flex">
                {{ title }}
            </div>
            <div class="d-inline-flex" style="width: 28px"></div>
        </v-flex>
        <v-form
            ref="form"
            v-model="valid"
            lazy-validation
            class="auth-form w-100"
            @submit.prevent
        >
            <div class="container-form" v-if="roomData">
                <v-layout row ma-0>
                    <v-flex class="d-inline-flex auth-form__input">
                        <label for="name" class="main-text"> Название </label>
                        <v-text-field
                            v-model="data.name"
                            placeholder="Название"
                            id="name"
                            class="dark-input"
                            :rules="[rules.required]"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input">
                        <label for="deviceType" class="main-text"> Тип устройства </label>
                        <v-select
                            v-model="deviceType"
                            placeholder="Тип устройства"
                            id="deviceType"
                            class="dark-input dark-input-select error-field"
                            :items="deviceTypesAvailable"
                            item-text="name"
                            item-value="code"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="[rules.required]"
                            :disabled="!!deviceId"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input">
                        <label for="location" class="main-text"> Расположение </label>
                        <v-combobox
                            v-model="data.location"
                            placeholder="Расположение"
                            id="location"
                            class="dark-input"
                            :items="locations"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="[rules.required]"
                            hide-details
                            @update:search-input="setLocation"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-combobox>
                    </v-flex>
                    <v-flex
                        class="d-inline-flex auth-form__input"
                        v-for="(option, index) in deviceOptions"
                        :key="index"
                    >
                        <label :for="`option-${option.key}`" class="main-text"> {{option.name}} </label>
                        <v-select
                            v-model="options[option.key]"
                            :placeholder="option.name"
                            :id="`option-${option.key}`"
                            class="dark-input dark-input-select error-field"
                            :items="option.values"
                            item-text="name"
                            item-value="key"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 13">
                        <label for="launchInterval" class="main-text"> Интервал работы (частота рассчёта) </label>
                        <v-text-field
                            v-model="launchInterval"
                            placeholder="Интервал работы (частота рассчёта)"
                            id="launchInterval"
                            class="dark-input error-field"
                            type="number"
                            min="1"
                            max="30"
                            :rules="[rules.min_time, rules.max_time]"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 || data.device_type == 13">
                        <label for="relayType" class="main-text"> Состояние реле </label>
                        <v-select
                            v-model="relayType"
                            placeholder="Состояние реле"
                            id="relayType"
                            class="dark-input dark-input-select error-field"
                            :items="relayTypes"
                            item-text="name"
                            item-value="key"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="[rules.required]"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12">
                        <label for="tSensorsLogic" class="main-text"> Расчет температуры </label>
                        <v-select
                            v-model="tSensorsLogic"
                            placeholder="Расчет температуры"
                            id="tSensorsLogic"
                            class="dark-input dark-input-select error-field"
                            :items="tSensorsLogicValues"
                            item-text="name"
                            item-value="key"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            :rules="[rules.required]"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 || data.device_type == 13">
                        <label for="additionalRelay" class="main-text"> Устройства для синхронизации </label>
                        <v-select
                            v-model="additionalRelay"
                            placeholder="Устройства для синхронизации"
                            id="additionalRelay"
                            class="dark-input dark-input-select error-field"
                            :items="heatingDevices"
                            item-text="name"
                            item-value="uid"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            multiple
                        >
                            <template v-slot:item="{item, tile}">
                                <v-flex style="padding: 10px 22px">
                                    <v-checkbox :input-value="tile.props.uid"/>
                                    <div>{{ item.name }}</div>
                                </v-flex>
                            </template>
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12">
                        <label for="tSensors" class="main-text"> Датчики температуры </label>
                        <v-select
                            v-model="tSensors"
                            placeholder="Датчики температуры"
                            id="tSensors"
                            class="dark-input dark-input-select error-field"
                            :items="temperatureSensors"
                            item-text="name"
                            item-value="uid"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                            multiple
                        >
                            <template v-slot:item="{item, tile}">
                                <v-flex style="padding: 10px 22px">
                                    <v-checkbox :input-value="tile.props.uid"/>
                                    <div>{{ item.name }}</div>
                                </v-flex>
                            </template>
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                            <template #no-data>
                                <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12">
                        <label for="tOffset" class="main-text"> Смещение температуры </label>
                        <v-text-field
                            v-model="tOffset"
                            placeholder="Смещение температуры"
                            id="tOffset"
                            class="dark-input error-field"
                            type="number"
                            min="-10.0"
                            max="10.0"
                            step="0.1"
                            :rules="[rules.min_offset, rules.max_offset]"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12">
                        <label for="tHysteresis" class="main-text"> Гистерезис </label>
                        <v-text-field
                            v-model="tHysteresis"
                            placeholder="Гистерезис"
                            id="tHysteresis"
                            class="dark-input error-field"
                            type="number"
                            min="0"
                            max="10.0"
                            :rules="[rules.min_hysteresis, rules.max_hysteresis]"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12">
                        <label for="modeType" class="main-text"> Режим работы </label>
                        <v-select
                            v-model="modeType"
                            placeholder="Режим работы"
                            id="modeType"
                            class="dark-input dark-input-select error-field"
                            :items="modeTypes"
                            item-text="name"
                            item-value="key"
                            :menu-props="{
                                bottom: true,
                                offsetY: true,
                                closeOnContentClick: true,
                            }"
                        >
                            <template #item="{item}">
                                <v-flex style="padding: 10px 22px">{{item.name}}</v-flex>
                            </template>
                            <template #selection="{item}">
                                <v-flex>{{item.name}}</v-flex>
                            </template>
                        </v-select>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 && modeType">
                        <label for="launchIntervalPID" class="main-text"> Интервал работы (частота рассчёта) </label>
                        <v-text-field
                            v-model="launchInterval"
                            placeholder="Интервал работы (частота рассчёта)"
                            id="launchIntervalPID"
                            class="dark-input error-field"
                            type="number"
                            min="1"
                            max="30"
                            :rules="[rules.min_time, rules.max_time]"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 && modeType">
                        <label for="kp" class="main-text"> Пропорциональный коэффициент </label>
                        <v-text-field
                            v-model="kp"
                            placeholder="Пропорциональный коэффициент"
                            id="kp"
                            class="dark-input error-field"
                            type="number"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 && modeType">
                        <label for="ki" class="main-text"> Интегральный коэффициент </label>
                        <v-text-field
                            v-model="ki"
                            placeholder="Интегральный коэффициент"
                            id="ki"
                            class="dark-input error-field"
                            type="number"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 && modeType">
                        <label for="kd" class="main-text"> Дифференциальный коэффициент </label>
                        <v-text-field
                            v-model="kd"
                            placeholder="Дифференциальный коэффициент"
                            id="kd"
                            class="dark-input error-field"
                            type="number"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 && modeType">
                        <label for="minPower" class="main-text"> Минимальная мощность (%) </label>
                        <v-text-field
                            v-model="minPower"
                            placeholder="Минимальная мощность (%)"
                            id="minPower"
                            class="dark-input error-field"
                            type="number"
                            :rules="[rules.min_power, rules.max_power]"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 && modeType">
                        <label for="maxErrorsCount" class="main-text"> Максимальное число ошибок </label>
                        <v-text-field
                            v-model="maxErrorsCount"
                            placeholder="Максимальное число ошибок"
                            id="maxErrorsCount"
                            class="dark-input error-field"
                            type="number"
                            :rules="[rules.min_errors, rules.max_errors]"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                    <v-flex class="d-inline-flex auth-form__input" v-if="data.device_type == 12 && modeType">
                        <label for="workingConditionDeltaTemperature" class="main-text"> Дельта температуры </label>
                        <v-text-field
                            v-model="workingConditionDeltaTemperature"
                            placeholder="Дельта температуры"
                            id="workingConditionDeltaTemperature"
                            class="dark-input error-field"
                            type="number"
                            :rules="[rules.min_delta, rules.max_delta]"
                            @keypress="checkNumber($event)"
                        ></v-text-field>
                    </v-flex>
                </v-layout>
                <v-layout row ma-0 w-100 justify-end>
                    <v-flex class="auth-form__input d-flex justify-space-between align-end">
                        <div class="d-inline-flex btn-block mb-2" style="width: auto; max-width: 50%;">
                            <v-switch
                                v-model="!data.hidden"
                                inset
                                dense
                                class="pa-0 ma-0"
                                color="#FF8484"
                            ></v-switch>
                            <div class="main-text ml-2">Доступно гостю</div>
                        </div>
                        <div class="d-inline-flex mb-4">
                            <v-btn class="btn-dark main-text mr-2" @click="back">
                                Отмена
                            </v-btn>
                            <v-btn
                                class="yellow-btn small-btn common-text ma-0"
                                :disabled="!valid"
                                type="submit"
                                @click="validate"
                            >
                                Сохранить
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </div>
        </v-form>
        <ModalWaiting v-model="openModalWaiting"></ModalWaiting>
    </v-container>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";
import deviceTypesCode from "@/plugins/deviceTypesCode";
import {isNumber} from "@/utils";

export default {
    name: "DevicePage",
    components: {ModalWaiting},
    data() {
        return {
            controllerId: null,
            controllerData: {},
            roomId: null,
            roomData: {},
            zigbeeNumber: null,
            wiredNumber: null,
            zigbeeData: {},
            wiredData: {},
            deviceId: null,
            deviceData: {},
            data: {
                hidden: true,
            },
            controller: null,
            controllers: [],
            locations: [],
            deviceType: null,
            deviceTypes: deviceTypesCode,
            options: {},
            launchInterval: null,
            relayType: null,
            additionalRelay: [],
            tOffset: 0,
            tSensorsLogic: null,
            tSensorsLogicValues: [
                {
                    name: "Среднее арифметическое значение",
                    key: "avg",
                },
                {
                    name: "Минимальное значение",
                    key: "min",
                },
                {
                    name: "Медианное значение",
                    key: "median",
                },
                {
                    name: "Максимальное значение",
                    key: "max",
                },
            ],
            tHysteresis: 0,
            rules: {
                min_time: v => !!v && v > 0 || 'Минимальное значение 1 мин.',
                max_time: v => !!v && v < 31 || "Максимальное значение 30 мин.",
                min_offset: v => !!v && v > -10.1 || 'Минимальное значение -10.0°C',
                max_offset: v => !!v && v < 10.1 || "Максимальное значение 10.0°C",
                min_hysteresis: v => !!v && v >= 0 || 'Минимальное значение 0',
                max_hysteresis: v => !!v && v < 10.1 || "Максимальное значение 10.0",
                min_power: v => !!v && v >= 0 || "Минимальное значение 0%",
                max_power: v => !!v && v < 101 || "Максимальное значение 100%",
                min_errors: v => !!v && v > 1 || "Минимальное значение 2",
                max_errors: v => !!v && v < 31 || "Максимальное значение 30",
                min_delta: v => !!v && v >= 0.01 || "Минимальное значение 0.01",
                max_delta: v => !!v && v <= 20.00 || "Максимальное значение 20.00",
                required: v => !!v || !!v && v.length > 0 || "Обязательное поле",
            },
            relayTypes: [
                {
                    name: "Нормально открыто",
                    key: "normally_open",
                },
                {
                    name: "Нормально закрыто",
                    key: "normally_closed",
                },
            ],
            heatingDevices: [],
            temperatureSensors: [],
            tSensors: [],
            modeType: false,
            modeTypes: [
                {
                    name: "Обычный режим",
                    key: false,
                },
                {
                    name: "По ПИД-регулятору",
                    key: true,
                },
            ],
            kd: 0.01,
            ki: 0.10,
            kp: 1.00,
            minPower: 0,
            maxErrorsCount: 10,
            workingConditionDeltaTemperature: 2,
            valid: true,
            openModalWaiting: false,
        };
    },
    created() {
        this.controllerId = this.$route.params.id;
        this.deviceId = this.$route.query.device;
        this.zigbeeNumber = this.$route.query.zigbee;
        this.wiredNumber = this.$route.query.wired;
    },
    mounted() {
        if (this.controllerId) {
            this.getController();
        }
    },
    computed: {
        deviceOptions() {
            if (this.deviceType && !this.deviceId) {
                let options;
                if (this.zigbeeNumber) {
                    options = this.zigbeeData.devices_for_creating.find((el) => el.device_type == this.deviceType).options;
                }
                if (this.wiredNumber) {
                    options = this.wiredData.devices_for_creating.find((el) => el.device_type == this.deviceType).options;
                }
                options.forEach((el) => {
                    el.values.forEach((value) => {
                        value.disabled = !value.available;
                    });
                });
                return options;
            }
            return [];
        },
        deviceTypesAvailable() {
            let deviceList;
            if (this.zigbeeNumber) {
                deviceList = this.zigbeeData.devices_for_creating;
            }
            if (this.wiredNumber) {
                deviceList = this.wiredData.devices_for_creating;
            }
            if (deviceList) {
                let devices_for_creating = deviceList.map(el => {
                    return el.device_type;
                });
                let filteredDevices = this.deviceTypes.filter((el) => devices_for_creating.includes(el.code));
                deviceList.forEach((el) => {
                    filteredDevices.forEach((filteredEl) => {
                        if (el.device_type == filteredEl.code) {
                            filteredEl.disabled = !el.available;
                        }
                    });
                });
                return filteredDevices;
            }
            return [];
        },
        title() {
            if (this.deviceId) {
                return "Редактирование устройства";
            } else {
                return "Добавление устройства";
            }
        },
    },
    watch: {
        deviceType(val) {
            this.data.device_type = val;
            if (this.deviceType == 12 || this.deviceType == 13) {
                this.getHeatingDevices();
            }
        },
    },
    methods: {
        getController() {
            this.openModalWaiting = true;
            this.controllerData = {};
            this.$http.get('/controllers/home/controller/' + this.controllerId + '/')
                .then((response) => {
                    this.controllerData = response.data;
                    this.roomId = this.controllerData.home.uid;
                    if (this.roomId) {
                        this.getRoom();
                        this.getLocations();
                        if (this.deviceId) {
                            this.getDevice();
                        }
                    }
                    if (this.zigbeeNumber) {
                        this.zigbeeData = this.controllerData.zigbee_devices.find((el) => el.inner_number == this.zigbeeNumber);
                    }
                    if (this.wiredNumber) {
                        this.wiredData = this.controllerData.wired_devices.find((el) => el.inner_number == this.wiredNumber);
                    }                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        getRoom() {
            this.openModalWaiting = true;
            this.roomData = {
                free: false,
            };
            this.$http.get('/homes/home/homes/' + this.roomId + '/')
                .then((response) => {
                    this.roomData = response.data;
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        getDevice() {
            this.openModalWaiting = true;
            this.$http.get('/devices/home/devices/' + this.deviceId + '/')
                .then((response) => {
                    this.deviceData = response.data;
                    this.setDevice();
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.openModalWaiting = false;
                });
        },
        setDevice() {
            this.data = JSON.parse(JSON.stringify(this.deviceData));
            this.deviceType = this.data.device_type;
            if (this.data.user_settings) {
                this.relayType = this.data.user_settings.relay_type;
                this.additionalRelay = this.data.user_settings.additional_relay;
                this.tOffset = parseFloat(this.data.user_settings.temperature_offset);
                this.tSensors = this.data.user_settings.temperature_sensors;
                this.tSensorsLogic = this.data.user_settings.temperature_sensors_logic;
                this.tHysteresis = parseFloat(this.data.user_settings.temperature_hysteresis);
            }
            this.modeType = this.data.pid_enabled;
            if (this.data.pid_enabled) {
                this.launchInterval = this.data.smart_pid ? this.data.smart_pid.launch_interval / 60 : 1;
                this.kp = parseFloat(this.data.smart_pid.kp);
                this.ki = parseFloat(this.data.smart_pid.ki);
                this.kd = parseFloat(this.data.smart_pid.kd);
                this.minPower = this.data.smart_pid.min_pow;
                this.maxErrorsCount = this.data.smart_pid.max_errors_count;
                this.workingConditionDeltaTemperature = parseFloat(this.data.smart_pid.working_condition_delta_temperature);
            } else {
                this.launchInterval = this.data.user_settings ? this.data.user_settings.launch_interval / 60 : 1;
            }
        },
        getLocations() {
            this.devices = [];
            this.$http.get('/devices/home/devices-list/' + this.roomId + '/')
                .then((response) => {
                    this.locations = response.data.locations;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        setLocation(val) {
            this.data.location = val;
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.addDevice();
            }
        },
        addDevice() {
            if (!this.deviceId) {
                this.data.controller = this.controllerId;
                this.data.inner_name = this.zigbeeNumber || this.wiredNumber;
                this.data.settings = this.options;
            }
            if (this.data.device_type == 12) {
                this.data.user_settings = {
                    relay_type: this.relayType,
                    additional_relay: this.additionalRelay,
                    temperature_offset: Number(parseFloat(this.tOffset).toFixed(2)),
                    temperature_sensors: this.tSensors,
                    temperature_sensors_logic: this.tSensorsLogic,
                    temperature_hysteresis: Number(parseFloat(this.tHysteresis).toFixed(2)),
                    smart_pid: {
                        enabled: this.modeType,
                        launch_interval: !!this.launchInterval ? this.launchInterval * 60 : 60,
                        power: 0,
                        errors: [],
                        statuses: [],
                        kp: Number(parseFloat(this.kp).toFixed(2)),
                        ki: Number(parseFloat(this.ki).toFixed(2)),
                        kd: Number(parseFloat(this.kd).toFixed(2)),
                        min_pow: this.minPower,
                        max_errors_count: this.maxErrorsCount,
                        working_condition_delta_temperature: Number(parseFloat(this.workingConditionDeltaTemperature).toFixed(2)),
                    },
                };
            }
            if (this.data.device_type == 13) {
                this.data.user_settings = {
                    statuses: [],
                    launch_interval: !!this.launchInterval ? this.launchInterval * 60 : 60,
                    relay_type: this.relayType,
                    additional_relay: this.additionalRelay,
                };
            }
            this.dialog = false;
            let url = "";
            let method = "post";
            if (this.deviceId) {
                url = this.deviceId + "/";
                method = "patch";
            }
            this.$http[method]('/devices/home/devices/' + url, this.data)
                .then(() => {
                    this.back();
                })
                .catch((error) => {
                    console.log(error);
                    this.dialog = true;
                });
        },
        back() {
            if (this.zigbeeNumber) {
                this.$router.push({ name: "controllerpage", params: { id: this.controllerId } });
            }
            if (this.wiredNumber) {
                this.$router.push({ name: "debugcontrollerpage", params: { id: this.controllerId } });
            }
        },
        checkNumber(evt) {
            return isNumber(evt);
        },
        getHeatingDevices() {
            this.heatingDevices = [];
            this.$http.get('devices/home/devices-list/' + this.roomId + '/?controller=' + this.controller)
                .then((response) => {
                    this.temperatureSensors = response.data.devices.filter(el => el.device_type == 7);
                    this.heatingDevices = response.data.devices.filter(el => el.device_type == 13);
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
}
</script>

<style lang="scss" scoped>
.main-container {
    height: 100%;
    text-align: center;

    .auth-form {
        width: 100%;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;
        padding: 0 40px;

        &__input {
            width: 100%;
            display: inline-flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 2px;
            margin-bottom: 8px;

            > label {
                margin-left: 20px;
            }
        }
    }
}

.btn-grey.v-btn {
    display: inline-flex;
    width: auto;
    padding: 10px 16px;
    text-transform: none;
    margin-right: 10px;
}

.dark-input {
    align-items: center;
}

.v-input.v-text-field {
    background: var(--rh-slider-dot) !important;
}

.v-input.dark-input {
    &::v-deep .v-input__control {
        .v-input__slot {
            margin-bottom: 0;
            top: 14px;

            .v-text-field__slot {
                height: 40px;
            }
        }

        .v-text-field__details {
            top: 12px;
            position: relative;
        }
    }

    &.error-field {
        &::v-deep .v-input__control {
            .v-text-field__details {
                top: 12px;
                position: relative;
            }
        }
    }

    &.v-select.v-select--is-multi {
        &::v-deep .v-input__control {
            .v-select__slot {
                max-height: 28px;
                display: -webkit-box;
                max-width: 700px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
                display: block;
            }
        }
    }
}

.small-btn.yellow-btn.v-btn {
    min-width: 64px;
    width: auto;
    display: inline-flex;
}
</style>